var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nuxt-link', {
    staticClass: "sale-banner",
    attrs: {
      "to": "/promo/66bdb898eae977320792762a/?utm_source=05ru&utm_medium=referrer&utm_campaign=bts&utm_content=banner-from-item-page&utm_term=discounts"
    }
  }, [_c('p', {
    staticClass: "sale-banner__text"
  }, [_vm._v("\n    Скидки\n    "), _c('img', {
    attrs: {
      "src": require("assets/images/banners/sale.svg"),
      "alt": "Скидкат"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sale-banner__time"
  }, [_vm._v("\n    ДО 30.09.24\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }